import { BaseAgent } from './BaseAgent';
import { AgentConfig } from './AgentProtocol';

export class AgentRegistry {
  private static instance: AgentRegistry;
  private agents: Map<string, BaseAgent> = new Map();
  private configs: Map<string, AgentConfig> = new Map();

  private constructor() {}

  public static getInstance(): AgentRegistry {
    if (!AgentRegistry.instance) {
      AgentRegistry.instance = new AgentRegistry();
    }
    return AgentRegistry.instance;
  }

  public registerAgent(agent: BaseAgent): void {
    const config = agent.getConfig();
    if (this.agents.has(config.id)) {
      console.warn(`Agent with ID ${config.id} already registered. Overwriting.`);
    }
    this.agents.set(config.id, agent);
    this.configs.set(config.id, config);
    console.log(`✅ Registered Agent: ${config.name} (${config.id})`);
  }

  public getAgent(id: string): BaseAgent | undefined {
    return this.agents.get(id);
  }

  public getAllAgents(): BaseAgent[] {
    return Array.from(this.agents.values());
  }

  public findAgentsByCapability(keyword: string): BaseAgent[] {
    return Array.from(this.agents.values()).filter(agent => {
      const config = agent.getConfig();
      return config.capabilities.some(cap => 
        cap.keywords.includes(keyword) || 
        cap.name.toLowerCase().includes(keyword.toLowerCase())
      );
    });
  }

  public getAgentConfig(id: string): AgentConfig | undefined {
    return this.configs.get(id);
  }
}

